import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import GTM_HANDLES from '#/shared/gtm-handles';
import * as Styled from './styled';

function TripHopCardFooter({
  paymentOptionHandler,
  copyTripURLHandler,
  copyTripNotifyVisible,
  printTripHandler,
  riderFeedbackHandler,
  editTripHandler,
  termsOfUseHandler,
  privacyPolicyHandler,
  isTransitTrip,
}) {
  const intl = useIntl();
  return (
    <Styled.TripHopCardFooterWrapper>
      {isTransitTrip && (
        <Styled.TripHopCardTopRow>
          <Styled.HopCardTripActionButton
            onClick={paymentOptionHandler}
            dataGtm={GTM_HANDLES.itinerary.footerPayButton}
          >
            <Styled.HopCardIconColumn>
              <Styled.HopCardIcon />
            </Styled.HopCardIconColumn>
            <Styled.HopCardHeaderTextColumn>
              {/* PI TODO: Add navigation to payment options below */}
              <Styled.HopCardHeaderText>
                <FormattedMessage id="planner.paytrip" />
              </Styled.HopCardHeaderText>
              <Styled.HopCardHeaderSubText>
                <FormattedMessage id="planner.payby" />
              </Styled.HopCardHeaderSubText>
            </Styled.HopCardHeaderTextColumn>
          </Styled.HopCardTripActionButton>
        </Styled.TripHopCardTopRow>
      )}
      <Styled.HopCardTripActionRow>
        <Styled.HopCardTripActionColumn>
          <Styled.HopCardTripActionButton
            onClick={editTripHandler}
            dataGtm={GTM_HANDLES.itinerary.footerEditButton}
          >
            <Styled.TripActionIconColumn>
              <Styled.EditTripActionIcon />
            </Styled.TripActionIconColumn>
            <FormattedMessage id="planner.edittrip" />
          </Styled.HopCardTripActionButton>
        </Styled.HopCardTripActionColumn>

        <Styled.HopCardTripActionColumn>
          <Styled.HopCardTripActionButton
            onClick={printTripHandler}
            dataGtm={GTM_HANDLES.itinerary.footerPrintButton}
          >
            <Styled.TripActionIconColumn>
              <Styled.PrintTripActionIcon />
            </Styled.TripActionIconColumn>
            <FormattedMessage id="planner.printtrip" />
          </Styled.HopCardTripActionButton>
        </Styled.HopCardTripActionColumn>
      </Styled.HopCardTripActionRow>

      <Styled.HopCardTripActionRow>
        <Styled.HopCardTripActionColumn>
          <Styled.HopCardTripActionButton
            onClick={riderFeedbackHandler}
            dataGtm={GTM_HANDLES.itinerary.footerFeedbackButton}
          >
            <Styled.TripActionIconColumn>
              <Styled.SendFeedbackActionIcon />
            </Styled.TripActionIconColumn>
            <FormattedMessage id="planner.sendfeedback" />
          </Styled.HopCardTripActionButton>
        </Styled.HopCardTripActionColumn>
        <Styled.HopCardTripActionColumn>
          <Styled.HopCardTripActionButton
            onClick={copyTripURLHandler}
            dataGtm={GTM_HANDLES.itinerary.footerCopyButton}
          >
            <Styled.TripActionIconColumn>
              <Styled.CopyTripActionIcon />
            </Styled.TripActionIconColumn>
            <FormattedMessage id="planner.copyurl" />
          </Styled.HopCardTripActionButton>
          <ScreenReaderText>
            {copyTripNotifyVisible && (
              <div
                role="alert"
                aria-label={intl.formatMessage({ id: 'planner.urlcopied' })}
              />
            )}
          </ScreenReaderText>
        </Styled.HopCardTripActionColumn>
      </Styled.HopCardTripActionRow>

      <Styled.HopCardTripFooterRow>
        <Styled.SiteLink onClick={termsOfUseHandler}>
          <FormattedMessage id="planner.termsofuse" />
        </Styled.SiteLink>
        {' | '}
        <Styled.SiteLink onClick={privacyPolicyHandler}>
          <FormattedMessage id="planner.privacypolicy" />
        </Styled.SiteLink>
      </Styled.HopCardTripFooterRow>
    </Styled.TripHopCardFooterWrapper>
  );
}

TripHopCardFooter.propTypes = {
  /** Navigates to the Hop Card Payment Option Page */
  paymentOptionHandler: PropTypes.func.isRequired,
  /** Copies the URL to recreate this trip and save it to clipboard */
  copyTripURLHandler: PropTypes.func.isRequired,
  /** show / hide the SR copy notify message */
  copyTripNotifyVisible: PropTypes.bool.isRequired,
  /** Navigates to the Print Friendly view of the planned trip */
  printTripHandler: PropTypes.func.isRequired,
  /** Navigates back to Trip Planner page */
  editTripHandler: PropTypes.func.isRequired,
  /** Navigates back to the rider feedback page */
  riderFeedbackHandler: PropTypes.func.isRequired,
  /** Navigates to the companies Privacy Policy Page */
  privacyPolicyHandler: PropTypes.func.isRequired,
  /** Navigates to the companies Terms of Use Page */
  termsOfUseHandler: PropTypes.func.isRequired,
  /** Determines whether to show Hop payment info */
  isTransitTrip: PropTypes.bool.isRequired,
};

export default TripHopCardFooter;
